module.exports = __webpack_public_path__ + "static/media/clouds_blue.3042ee87.svg";